module.exports = __webpack_public_path__ + "static/media/sumarDeshabilitado.02fb60d9.svg";